export async function getRankingAPI(season) {
    const response = await fetch(`/api/ranking?season=${season}`, {
        headers: {
          'accept': 'application/json',
        },
    } );
    const res = await response.json();
    return res;
  }